import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './styles/ChannelList.css'
import { getCommunityMembers, createDM } from '../../api'
import NewDmModal from './NewDmModal'
import ChannelSection from './ChannelSection'
import { loadUser } from '../../utils'
import { Toast } from 'antd-mobile'

const fetchCommunityMembers = async () => {
  try {
    const response = await getCommunityMembers()
    return response?.data || []
  } catch (err) {
    Toast.show('Error fetching community members')
    return []
  }
}

function getUniqueDmRooms(dmRooms = []) {
  const seen = new Set()
  return dmRooms.filter(dm => {
    const id = dm._id || dm.rid
    if (!id) return false
    if (seen.has(id)) return false
    seen.add(id)
    return true
  })
}

const ChannelList = ({
  channels = [],
  readReceipts = [],
  onSelectChannel,
  setReadReceipts,
  readReceiptsRef,
  isDm = false,
  userAvatars = []
}) => {
  const [showNewDm, setShowNewDm] = useState(false)
  const [communityMembers, setCommunityMembers] = useState([])
  const currentUser = loadUser()
  const navigate = useNavigate()

  useEffect(() => {
    if (showNewDm) {
      fetchCommunityMembers().then(setCommunityMembers)
    } else {
      setCommunityMembers([])
    }
  }, [showNewDm])

  if (!Array.isArray(channels) || channels.length === 0) return null

  const channelRooms = channels.filter(c => c?.t === 'p')
  let dmRooms = channels.filter(c => c?.t === 'd')
  dmRooms = getUniqueDmRooms(dmRooms, currentUser)

  const handleCreateDm = async user => {
    setShowNewDm(false)
    if (!user || !currentUser) return
    try {
      const response = await createDM({
        sender_id: currentUser?.id || currentUser?._id,
        recipient_id: user?._id || user?.id
      })
      const roomId = response?.data?.room?.rid
      if (roomId) {
        navigate(`/chat/${roomId}`, {
          state: {
            isDm: true,
            userAvatars: []
          }
        })
      } else {
        Toast.show('Failed to create DM room')
      }
    } catch (err) {
      Toast.show('Error creating DM room')
    }
  }

  return (
    <div className="channel-list-wrapper">
      {channelRooms.length > 0 && (
        <ChannelSection
          title="Channels"
          channels={channelRooms}
          isDm={false}
          readReceipts={readReceipts}
          onSelectChannel={onSelectChannel}
          setReadReceipts={setReadReceipts}
          readReceiptsRef={readReceiptsRef}
          userAvatars={userAvatars}
        />
      )}
      {dmRooms.length > 0 && (
        <ChannelSection
          title="Direct Messages"
          channels={dmRooms}
          isDm={true}
          readReceipts={readReceipts}
          onSelectChannel={onSelectChannel}
          setReadReceipts={setReadReceipts}
          readReceiptsRef={readReceiptsRef}
          showAddButton={true}
          onAddClick={() => setShowNewDm(true)}
          userAvatars={userAvatars}
        />
      )}
      <NewDmModal
        open={showNewDm}
        onClose={() => setShowNewDm(false)}
        communityMembers={communityMembers}
        onCreate={handleCreateDm}
      />
    </div>
  )
}

export default ChannelList
